'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

exports.default = makeBodyClick;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Wraps a component and gives it the ability to handle clicks on any element,
 * including itself and it's children.
 */
function makeBodyClick() {
  var method = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'onBodyClick';

  function decorator(Component) {
    var newName = 'Wrapped' + (Component.name || Component.displayName);

    var Wrapped = function (_React$Component) {
      (0, _inherits3.default)(Wrapped, _React$Component);

      function Wrapped() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, Wrapped);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Wrapped.__proto__ || (0, _getPrototypeOf2.default)(Wrapped)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (e) {
          _this.__wrappedComponent[method](e);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
      }

      (0, _createClass3.default)(Wrapped, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          this.__wrappedComponent = this.refs.wrappedComponent;
          document.addEventListener('click', this.handleClick, true);
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          document.removeEventListener('click', this.handleClick, true);
        }
      }, {
        key: 'render',
        value: function render() {
          return _react2.default.createElement(Component, (0, _extends3.default)({}, this.props, { ref: 'wrappedComponent' }));
        }
      }]);
      return Wrapped;
    }(_react2.default.Component);

    Wrapped.displayName = newName;
    return Wrapped;
  }

  return decorator;
}
//# sourceMappingURL=bodyClick.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@taxfyle/web-commons/lib/decorators/bodyClick.js
// module id = 629
// module chunks = 0